import {FC} from 'react';

import {Avatar, IconButton, Stack, Tooltip, Typography, Checkbox, Box} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FlagIcon from '@mui/icons-material/Flag';

import {IWorkerSelectOption} from '../../../api/strategies/searchWorkersStrategy';
import {useRecoilValue} from 'recoil';
import {accountGroupUsersSelectionToRegroupState, editGroupModeState} from '../../../store/user-groups/atoms';
import {IUserAccount} from '../../../shared/types/user-account.types';

interface IUserRow {
  user: IWorkerSelectOption<IUserAccount>;
  removeUser: () => void;
  assignLeader: () => void;
  selectToRegroup?: (row: IWorkerSelectOption<IUserAccount>, isSelected: boolean, isLeader: boolean) => () => void;
  isLeader: boolean;
  isGroupPredefined?: boolean;
  loading: boolean;
}

const rowStyle = {
  padding: '0 5px',
  justifyContent: 'space-between',
  borderBottom: '1px solid #e0e0e0',
};

export const UserRowOfGroup: FC<IUserRow> = ({
  user,
  removeUser,
  assignLeader,
  selectToRegroup,
  isLeader,
  loading,
  isGroupPredefined,
}) => {
  const {usersToRegroup} = useRecoilValue(accountGroupUsersSelectionToRegroupState);
  const editMode = useRecoilValue(editGroupModeState);

  const isSelected = usersToRegroup.some((i) => i === user.value.id);

  return (
    <Stack
      sx={{
        ...rowStyle,
        backgroundColor: isLeader && editMode !== 'REGROUP' ? '#ffbdad' : '#fff',
        '&:hover': {
          backgroundColor: isLeader && editMode !== 'REGROUP' ? '#ffb29f' : '#f3f3f3',
        },
      }}
      direction="row"
    >
      <Stack direction="row" spacing={1} sx={{alignItems: 'center'}}>
        {editMode === 'REGROUP' &&
          selectToRegroup &&
          (isLeader ? (
            <Tooltip title="Руководителя нельзя перенести в другую группу">
              <Box>
                <Checkbox disabled />
              </Box>
            </Tooltip>
          ) : (
            <Checkbox checked={isSelected} disabled={loading} onClick={selectToRegroup(user, isSelected, isLeader)} />
          ))}
        <Avatar sx={{width: 28, height: 28}} src={user.photo || ''} />
        <Typography variant="subtitle2">{user.label}</Typography>
        {isLeader && editMode === 'REGROUP' && <FlagIcon color="primary" />}
      </Stack>
      <Stack direction="row" spacing={1.5}>
        {editMode !== 'REGROUP' && (
          <>
            {!isGroupPredefined && (
              <Tooltip title="Назначить руководителем группы">
                <IconButton disabled={loading} onClick={assignLeader}>
                  <FlagIcon color="primary" />
                </IconButton>
              </Tooltip>
            )}
            <IconButton disabled={loading} onClick={removeUser}>
              <DeleteForeverIcon color="error" />
            </IconButton>
          </>
        )}
      </Stack>
    </Stack>
  );
};
